import {appRouter} from '@netx/core-next/instance/router';

export const routeToAsset = (
	id: number,
	extra = '',
	disableTrigger?: boolean,
) =>
	appRouter.navigate(`asset/${id}${extra ? `/${extra}` : ''}`, !disableTrigger);

export default routeToAsset;
